// Interfaces
export interface DayConfig {
    day: number;
    gift: number;
    turnover_times: number;
    createTime: number;
    activeStatus: number;
}

export interface RechargeConfig {
    title: string;
    amount: number;
    days: DayConfig[];
}

export interface ReturnTurnoverConfig {
    config: RechargeConfig[];
    turnoverLevel: number;
}

export interface DailyRewardData {
    createTime: string;
    dayCount: number;
    status: number;
    d2: number;
    d3: number;
    d4: number;
    d5: number;
    d6: number;
    d7: number;
    remainGiftAmount: number;
    claimGiftAmount: number;
    coin: number;
    rewards: FutureRewards[],
}
export interface FutureRewards {
    amount: string,
    date: string
}

export interface ReturnTurnOverData {
    active : number;
    showLeft : boolean;
    showRight : boolean;
    tabsRef : any;
    dayCountVal : number
    isReturnTurnover : boolean;
    returnTurnoverConfig : ReturnTurnoverConfig | null;
    activityDescription : string[]
    dailyRewardList :DailyRewardData[]
    weeklyRewardList : DailyRewardData[]
    historyList : DailyRewardData[]
    cashbackTotal : number
    availableGiftAmount : number
    claimGiftAmount : number
    futureRewards : FutureRewards[]
    isHaveTodayDayRewards : boolean
    isHaveTodayRewards : boolean
    todayDayRewards : any
    todayRewards : any
    todayBetDetails : DailyRewardData
    total : number
    pageNum : number
    pageSize : number
    bannerIcon : string
}

// Constants

export const PAGE_SIZE = 20